const recordingAssuranceTutorial = {
  module: 'recording_assurance',
  moduleName: 'Recording Assurance',
  steps: [
    {
      target: '.ra-header',
      position: 'bottom',
      title: 'Recording Assurance',
      description: 'Continuous verification that every camera is recording as expected.',
    },
    {
      target: '.ra-gauge-card',
      position: 'right',
      title: 'Health Score',
      description: 'Overall recording confidence across all monitored cameras.',
    },
    {
      target: '.ra-summary-grid',
      position: 'top',
      title: 'Camera Status Grid',
      description: 'Quick view of which cameras are recording, degraded, or failing.',
    },
  ],
};

export default recordingAssuranceTutorial;
